module.exports = __webpack_public_path__ + "img/avatar4.8d2500bb.png";